export default {
	editorPanel: {
		minimizeTooltip: "minimize",
		readOnlySuffix: "(read-only)",
		featureModeTooltip: "Select and insert/change edits for threads, countersinks, etc.",
		measuringModeTooltip: "Measure geometry",
		weldModeTooltip: "Define weld seam",
		weldModeDisabledTooltip:
			"This material currently cannot be welded. Information on which materials can be " +
			"welded can be found at blexon.com/werkstoffe",
		rollDirectionModeTooltip: "Define roll direction",
		switchTopSideTooltip: "Switch top side",
		zoomToFit: "Zoom to fit",
		noValidationLabel: "No validation",
	},
	errorDialog: {
		closeButton: "Close",
	},
	messagePanel: {
		noMessages: "No messages",
	},
	modePanel: {
		minimizeTooltip: "minimize",
		noModeSelected: "No mode is currently selected.",
	},
	sendToHelpdesk: {
		title: "Send article to Blexon helpdesk",
		introText:
			"You are sending this article to the Blexon helpdesk. We will investigate the cause " +
			"of the error messages and fix it if possible. We are also happy to give you guidance " +
			"on how to modify the design so that the article becomes manufacturable. This service " +
			"is free of charge.",
		notificationText:
			"You will be notified by email as soon as the article has been processed. Reviews are " +
			"usually completed within hours during business hours.",
		lockNotice:
			"Please note that after sending, the article can no longer be modified or deleted " +
			"until it has been released by Blexon.",
		emailLabel: "Email for notifications regarding this article",
		emailPlaceholder: "Enter email address here...",
		emailRequiredError: "Email must be provided.",
		emailInvalidError: "This is not a valid email address.",
		submitButton: "Send and close",
		cancelButton: "Cancel",
	},
	unsavedChanges: {
		title: "Some changes have not yet been saved.",
		message: "Do you want to discard the changes?",
		discardButton: "Discard",
		cancelButton: "No",
	},
	validationMessage: {
		showFeaturesTooltip: "Show features in the model",
		correctTooltip: "Correct",
		learnMoreLink: "Learn more here...",
		releaseCutsWarningTitle: "Create release cut in the bend zone",
		releaseCutsWarningText1:
			"Creating the release cuts will remove existing threads, countersinks, extruded " +
			"collars and cylinder head counterbores, which will then need to be redefined.",
		releaseCutsWarningText2:
			"We recommend creating release cuts in the bend zone at the very start of editing.",
		createReleaseCutsButton: "Create release cut",
		cancelButton: "Cancel",
	},
	cadView: {
		gizmoRight: "Right",
		gizmoLeft: "Left",
		gizmoTop: "Top",
		gizmoBottom: "Bottom",
		gizmoFront: "Front",
		gizmoBack: "Back",
	},
};
